import { render, staticRenderFns } from "./TransferChannel.vue?vue&type=template&id=04acbc1d&scoped=true"
import script from "./TransferChannel.vue?vue&type=script&lang=js"
export * from "./TransferChannel.vue?vue&type=script&lang=js"
import style0 from "./TransferChannel.vue?vue&type=style&index=0&id=04acbc1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04acbc1d",
  null
  
)

export default component.exports